import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form, Icon } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import { FarmerCreateOptionsType } from '~/api/services/farmers'
import { StyledFormSection } from '../style'

interface Props {
  farmerOptions: FarmerCreateOptionsType
}

const CollectionTransport: React.FC<Props> = ({ farmerOptions }) => {
  const { t } = useTranslation()
  const { control } = useFormContext()

  return (
    <StyledFormSection>
      <div className='section-header'>
        <Icon name='truck' />
        <span className='section-title'>{t('Collection & Transport')}</span>
      </div>
      <div className='section-content'>
        <Form.Group widths={'equal'}>
          <FormFields.Select
            control={control}
            rules={{
              required: t('Please select collection cycle')
            }}
            placeholder={t('Please select collection cycle')}
            label={t('Collection Cycle')}
            name={'collectionCycleId'}
            options={farmerOptions?.collectionCycles
              ?.filter(collectionCycle => Boolean(collectionCycle?.name))
              .map(collectionCycle => ({
                value: collectionCycle.id,
                text: collectionCycle.name
              }))}
          />
          <FormFields.Select
            selectOnBlur={false}
            control={control}
            label={t('Collection Method')}
            name={'collectionMethodId'}
            clearable
            placeholder={t('Select collection method')}
            options={farmerOptions?.collectionMethods?.map(method => ({
              value: method.id,
              text: method.label
            })) || []}
          />
          <FormFields.Select
            selectOnBlur={false}
            control={control}
            label={t('Transport Area')}
            name={'transportAreaId'}
            clearable
            placeholder={t('Select transport area')}
            options={farmerOptions?.transportAreas?.map(transportArea => ({
              value: transportArea?.id,
              text: transportArea?.name
            })) || []}
          />
        </Form.Group>

        <Form.Group widths={'equal'}>
          <FormFields.Select
            control={control}
            name={'restrictionPeriodId'}
            label={t('Restriction Period')}
            selectOnBlur={false}
            rules={{
              required: t('Please select restriction period')
            }}
            placeholder={t('Select restriction period')}
            options={farmerOptions?.restrictionPeriods?.map(restrictionPeriod => ({
              text: restrictionPeriod.name,
              value: restrictionPeriod.id
            })) || []}
          />
          <FormFields.Select
            control={control}
            selectOnBlur={false}
            label={t('Collection Points')}
            name={'collectionPoints'}
            clearable
            multiple
            placeholder={t('Select collection points')}
            options={farmerOptions?.collectionPoints?.map(point => ({
              value: point?.id,
              text: point?.name
            })) || []}
          />
          <FormFields.Select
            control={control}
            selectOnBlur={false}
            label={t('Collection Sites')}
            name={'collectionSites'}
            clearable
            multiple
            placeholder={t('Select collection sites')}
            options={farmerOptions?.collectionSites?.map(site => ({
              value: site?.id,
              text: site?.name
            })) || []}
          />
        </Form.Group>
      </div>
    </StyledFormSection>
  )
}

export default CollectionTransport
